import { Currency } from '../../constants/currency.js';
import { getAmountRangeToString, getAmountString } from '../../helpers/humanization.js';

const getBrokerTerms = item => {
    const conditions = [];
    // комиссии за операции
    const { commissionFrom, commissionTo } = item;
    const params = {
        amountRange: {
            from: commissionFrom,
            to: commissionTo,
        },
        currency: Currency.RUB,
        isFloat: true,
    };
    conditions.push({
        value: getAmountRangeToString(params),
        description: 'Комиссии за операции',
        wide: true,
        key: 'commission',
    });
    // обслуживание
    const { service } = item;
    if (service < 1) {
        conditions.push({ value: 'Бесплатно', description: 'Обслуживание', key: 'price' });
    }
    else {
        conditions.push({ value: `${getAmountString(service)} ₽/мес`, description: 'Обслуживание', key: 'price' });
    }
    // Открытие ИИС
    const { haveIis } = item;
    conditions.push({ value: haveIis ? 'Возможно' : 'Невозможно', description: 'Открытие ИИС', key: 'iis' });
    return conditions;
};

export { getBrokerTerms };
//# sourceMappingURL=broker.js.map
